import { useQuery } from "@tanstack/react-query";
import { getSubmittedApplication } from "@/api/v1-jwt/platform-application/platform-application";
import { useProfile } from "@/hooks/profile/use-profile";
import { useAuth } from "@/providers/auth";

export const useKYBData = ({ queryFn, queryKey, enabled, ...rest } = {}) => {
  const { cognitoId } = useAuth();
  const { data: profile, isLoading } = useProfile();

  const isEnabled =
    !!cognitoId && enabled !== false && !!profile?.application_id && !isLoading;
  return useQuery({
    queryKey: ["application", profile?.application_id],
    queryFn: () => getSubmittedApplication(cognitoId, profile?.application_id),
    enabled: isEnabled,
    // staleTime: Infinity,
    ...rest,
  });
};
